export default "__VITE_ASSET__B6WOJU7Z__"